import { Text } from '@factorialco/deprecated-design-system'
import { WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  operator: WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnum
}

export const Operator = ({ operator }: Props) => {
  switch (operator) {
    case 'lt':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.lt`)}
        </Text>
      )
    case 'lte':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.lte`)}
        </Text>
      )
    case 'gt':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.gt`)}
        </Text>
      )
    case 'gte':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.gte`)}
        </Text>
      )
    case 'neq':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.neq`)}
        </Text>
      )
    case 'eq':
      return (
        <Text whiteSpace="nowrap" size="200">
          {i18n.t(`workflows.node_type.condition.operations.eq`)}
        </Text>
      )
  }
}
